import cx from 'classnames';
import { range } from 'lodash';
import { RiStarFill } from 'react-icons/ri';
import { ComponentPropsWithoutRef } from 'react';
import styles from './Rating.module.scss';

export interface RatingProps extends ComponentPropsWithoutRef<'div'> {
  maxRating?: number;
  rating: number;
  size?: string;
}

function Rating({
  maxRating = 5,
  rating,
  size = '1rem',
  ...props
}: RatingProps) {
  return (
    <div {...props} className={cx(props.className, styles.stars)}>
      {range(maxRating).map((i) => (
        <RiStarFill
          className={cx(styles.star, rating > i && styles.starShow)}
          size={size}
          key={i}
        />
      ))}
    </div>
  );
}

export default Rating;
